module.exports = __webpack_public_path__ + "img/vip3days.f719dc24.png";